import { useState } from "react";
import { GlobalVariables } from "../globalVar";
import { toast } from "react-toastify";
import { getToast } from "../utils/toastConfig";

export const useDownloadReport = () => {
  const [loading, setLoading] = useState(false);

  const downloadReport = (visitId, hasChildren) => {
    console.log('🚀 ~ visitId:', visitId);
    setLoading(true);
    try {
      const url = `${GlobalVariables.getURL()}downloadReport/${visitId}?hasChildren=${hasChildren}`;
      window.open(url, "_blank");
      getToast({ status: 'info', title: 'Proceso de descarga de reporte iniciado' });
    } catch (error) {
      console.error(error);
      getToast({ status: 'error', title: 'Error durante el proceso de descarga de reporte' });
    } finally {
      setLoading(false);
      getToast({ status: 'info', title: 'Proceso de descarga de reporte finalizado' });
    }
  };

  return { loading, downloadReport };
};
